module.exports = __webpack_public_path__ + "static/img/Twitter_WHITE.e7ed5ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/landing/Twitter_WHITE.png
// module id = nXLN
// module chunks = 1